<template>
  <div class="p-5">
    <div class="pb-6 text-center">
      <div class="pb-3">
        <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
      </div>
      <p v-text="i18n.message"></p>
    </div>
    <div class="flex pt-6 justify-between items-center">
      <button
        class="button action"
        v-text="i18n.action.retry.label"
        @click="$emit('close')"
      ></button>
      <button
        class="button action"
        v-text="i18n.action.support.label"
        @click="gotoSupport"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["i18n"],
  methods: {
    gotoSupport() {
      window.location.href =
        this.i18n.action.support.route +
        "?q=bug&faulty_software=website&subject=" +
        this.i18n.action.support.subject;
    },
  },
};
</script>
